import { render, staticRenderFns } from "./ThreeWidth.vue?vue&type=template&id=e384f296&scoped=true"
import script from "./ThreeWidth.vue?vue&type=script&lang=js"
export * from "./ThreeWidth.vue?vue&type=script&lang=js"
import style0 from "./ThreeWidth.vue?vue&type=style&index=0&id=e384f296&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e384f296",
  null
  
)

export default component.exports